import isNil from 'lodash-es/isNil';
import { useCallback } from 'react';
import { queryClient, useClient, useMutation } from '../..';
import { isPlotSummary, isStationSummary } from '../../resources/measurements.type';
const useToggleIsFavorite = ({ summary, summariesQueryCacheKey, onSuccess }) => {
    const client = useClient();
    const isPlot = isPlotSummary(summary);
    const { id, isFavorite } = isPlot ? summary.metadata.plot : summary.metadata.station;
    const onMutate = useCallback(() => {
        const previousSummaries = queryClient.getQueryData(summariesQueryCacheKey);
        const isMatchingSummary = (x) => isPlotSummary(x) ? x.metadata.plot.id === id : x.metadata.station.id === id;
        const previousMatchingSummary = previousSummaries?.find(isMatchingSummary);
        const previousMatchingSummaryIndex = previousSummaries
            ? previousSummaries?.findIndex(isMatchingSummary)
            : -1;
        let newSummary;
        if (!isNil(previousMatchingSummary) && isPlotSummary(previousMatchingSummary)) {
            newSummary = {
                ...previousMatchingSummary,
                metadata: {
                    ...previousMatchingSummary?.metadata,
                    plot: {
                        ...previousMatchingSummary?.metadata.plot,
                        isFavorite: !isFavorite
                    }
                }
            };
        }
        else if (!isNil(previousMatchingSummary) && isStationSummary(previousMatchingSummary)) {
            newSummary = {
                ...previousMatchingSummary,
                metadata: {
                    ...previousMatchingSummary?.metadata,
                    station: {
                        ...previousMatchingSummary?.metadata.station,
                        isFavorite: !isFavorite
                    }
                }
            };
        }
        const newSummaries = !isNil(previousSummaries)
            ? [
                ...previousSummaries.slice(0, previousMatchingSummaryIndex),
                newSummary,
                ...previousSummaries.slice(previousMatchingSummaryIndex + 1)
            ]
            : [];
        queryClient.setQueryData(summariesQueryCacheKey, newSummaries);
        return () => queryClient.setQueryData(summariesQueryCacheKey, previousSummaries);
    }, [id, isFavorite, summariesQueryCacheKey]);
    const [setFavoriteMutation, setFavoriteRequest] = useMutation(client.plots.setFavorite(id), {
        onMutate,
        onSuccess
    });
    const [unsetFavoriteMutation, unsetFavoriteRequest] = useMutation(client.plots.unsetFavorite(id), {
        onMutate,
        onSuccess
    });
    const [toggleFavorite, toggleFavoriteRequest] = useMutation(client.stations.changeFavorite(id), {
        onMutate,
        onSuccess
    });
    return isPlot
        ? {
            type: 'isPlot',
            mutation: isFavorite ? unsetFavoriteMutation : setFavoriteMutation,
            request: isFavorite ? unsetFavoriteRequest : setFavoriteRequest
        }
        : {
            type: 'isStation',
            mutation: toggleFavorite,
            request: toggleFavoriteRequest
        };
};
export default useToggleIsFavorite;
